// src/pages/MemberImport.jsx
import { useState, useEffect } from 'react';
import { api } from '../api';
import { Card, PageHeader, Btn, Field, Input, Flash } from '../components/UI';

export default function MemberImport() {
  const [file, setFile]         = useState(null);
  const [startNum, setStartNum] = useState('1');
  const [loading, setLoading]   = useState(false);
  const [flash, setFlash]       = useState(null);
  const [result, setResult]     = useState(null);

  useEffect(() => {
    api.suggestedImportStart().then(res => {
      if (res?.ok && res.data?.suggested_start) {
        setStartNum(String(res.data.suggested_start));
      }
    });
  }, []);

  async function doImport() {
    if (!file) { setFlash({ type: 'error', msg: 'Select a CSV file first.' }); return; }
    setLoading(true); setResult(null); setFlash(null);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('start_number', startNum);
    const res = await fetch(`${process.env.REACT_APP_API_BASE || ''}/api/membership-import`, {
      method: 'POST', credentials: 'include', body: formData,
    });
    const data = await res.json();
    setLoading(false);
    if (res.ok) setResult(data);
    else setFlash({ type: 'error', msg: data.error || 'Import failed.' });
  }

  return (
    <div style={{ padding: '20px 16px', maxWidth: 860, margin: '0 auto' }}>
      <PageHeader title="Member Import" subtitle="Upload a CSV membership list to add new members." />
      {flash && <Flash type={flash.type} onDismiss={() => setFlash(null)}>{flash.msg}</Flash>}

      <Card style={{ padding: 20, marginBottom: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16, marginBottom: 16 }}>
          <Field label="CSV File">
            <input type="file" accept=".csv" onChange={e => setFile(e.target.files[0])}
              style={{ padding: '7px 0', fontSize: 13, color: 'var(--fg)' }} />
          </Field>
          <Field label="Starting Membership #">
            <Input type="number" min="1" value={startNum} onChange={e => setStartNum(e.target.value)} />
          </Field>
        </div>
        <Btn onClick={doImport} disabled={loading}>{loading ? 'Importing...' : 'Import CSV'}</Btn>
      </Card>

      {result && (
        <Card>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', background: 'var(--bg2)' }}>
            <span style={{ fontSize: 12, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 0.8, color: 'var(--fg2)' }}>Import Results</span>
          </div>
          <div style={{ display: 'flex', gap: 20, padding: '16px 20px', flexWrap: 'wrap' }}>
            {[
              ['Added', result.added?.length || 0, 'var(--success)'],
              ['Updated', (result.skipped || []).filter(s => s.updated).length, 'var(--accent)'],
              ['Unchanged', (result.skipped || []).filter(s => !s.updated).length, 'var(--fg3)'],
              ['Resigned', result.resigned_count || 0, 'var(--warning)'],
            ].map(([label, val, color]) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 28, fontWeight: 'bold', color }}>{val}</div>
                <div style={{ fontSize: 12, color: 'var(--fg3)' }}>{label}</div>
              </div>
            ))}
          </div>
          {(result.skipped || []).filter(s => s.updated).length > 0 && (
            <div style={{ padding: '0 16px 16px' }}>
              <div style={{ fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', color: 'var(--fg3)', marginBottom: 8 }}>Members Updated</div>
              <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 'var(--radius)' }}>
                {result.skipped.filter(s => s.updated).map((m, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 12px', borderBottom: '1px solid var(--border-light)', fontSize: 12 }}>
                    <span style={{ fontWeight: 'bold' }}>{m.lastname}</span>
                    <span style={{ color: 'var(--accent)', fontSize: 11 }}>#{m.membership_number} · changed: {(m.changed_fields || []).join(', ')}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {result.added?.length > 0 && (
            <div style={{ padding: '0 16px 16px' }}>
              <div style={{ fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', color: 'var(--fg3)', marginBottom: 8 }}>New Members Added</div>
              <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid var(--border)' }}>
                {result.added.map((m, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 12px', borderBottom: '1px solid var(--border-light)', fontSize: 12 }}>
                    <span style={{ fontWeight: 'bold' }}>{m.lastname}</span>
                    <span style={{ color: 'var(--fg3)' }}>#{m.membership_number} · {m.membership_type}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Card>
      )}
    </div>
  );
}
